export default __webpack_public_path__ + "static/living_room-e943840d070095dff819cef1535076d8.jpg";